import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBillingIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2626_2312)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M4.77725 4.00977H2.7318C2.37014 4.00977 2.0233 4.15343 1.76756 4.40917C1.51183 4.6649 1.36816 5.01174 1.36816 5.3734C1.36816 5.73506 1.51183 6.08191 1.76756 6.33764C2.0233 6.59337 2.37014 6.73704 2.7318 6.73704H4.09544C4.4571 6.73704 4.80394 6.88071 5.05967 7.13644C5.3154 7.39217 5.45907 7.73902 5.45907 8.10068C5.45907 8.46233 5.3154 8.80918 5.05967 9.06491C4.80394 9.32064 4.4571 9.46431 4.09544 9.46431H1.70907",
				stroke: "#FEFEFF",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.41357 3.32715V4.00897",
				stroke: "#FEFEFF",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.41357 9.46387V10.1457",
				stroke: "#FEFEFF",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.50484 4.00977H18.4139V15.6007C18.4139 15.7815 18.3421 15.9549 18.2142 16.0828C18.0864 16.2107 17.9129 16.2825 17.7321 16.2825H2.73211C2.55128 16.2825 2.37786 16.2107 2.24999 16.0828C2.12213 15.9549 2.05029 15.7815 2.05029 15.6007V12.1916",
				stroke: "#FEFEFF",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.18652 8.10059H18.4138",
				stroke: "#FEFEFF",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.14111 12.1914H18.4138",
				stroke: "#FEFEFF",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.6411 8.10059V16.2824",
				stroke: "#FEFEFF",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2626_2312",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgBillingIcon;
